const isNil = (value) => {
  return value === void 0 || value === null;
};

export { isNil };
//# sourceMappingURL=isNil.mjs.map
